import { Controller, useFormContext } from 'react-hook-form';
import { Button, Modal, ToggleValueInput, useLocale } from 'shared-ui';

import { AppMessages } from 'i18n/messages';
import { PasswordValidationInfo } from 'ui/passwordValidationInfo/PasswordValidationInfo';

import * as Styled from './ChangePassword.styles';
import { ChangePasswordProps, ChangePasswordForm } from './ChangePassword.types';

export const ChangePassword = ({
  onSubmit,
  onModalClose,
  onModalOpen,
  isModalOpen,
  isLoading,
  passwordPolicy,
}: ChangePasswordProps) => {
  const { formatMessage } = useLocale();

  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
    getFieldState,
  } = useFormContext<ChangePasswordForm>();

  const newPassword = getFieldState('newPassword');
  const repeatPassword = getFieldState('repeatPassword');
  const isError = newPassword.invalid || repeatPassword.invalid;

  return (
    <>
      <Button variant="contained" color="primary" onClick={onModalOpen}>
        {formatMessage({ id: AppMessages['profile.changePassword'] })}
      </Button>

      <Modal
        header={formatMessage({ id: AppMessages['profile.changePassword.title'] })}
        open={isModalOpen}
        onClose={onModalClose}
        size="medium"
        type="form"
        onSubmit={handleSubmit(onSubmit)}
        submitButtonDisabled={isLoading || !isValid}
        submitButtonText={formatMessage({ id: AppMessages['profile.changePassword.actionButton'] })}
      >
        <Styled.Wrapper>
          <Controller
            name="oldPassword"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <ToggleValueInput
                {...field}
                errorMessage={errors.oldPassword?.message}
                type="password"
                label={formatMessage({ id: AppMessages['profile.changePassword.oldPassword.label'] })}
                placeholder={formatMessage({
                  id: AppMessages['profile.changePassword.oldPassword.placeholder'],
                })}
                required
              />
            )}
          />

          <br />

          <Controller
            name="newPassword"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <ToggleValueInput
                {...field}
                errorMessage={errors.newPassword?.message}
                type="password"
                label={formatMessage({ id: AppMessages['profile.changePassword.password.label'] })}
                placeholder={formatMessage({
                  id: AppMessages['profile.changePassword.password.placeholder'],
                })}
                required
              />
            )}
          />

          <Controller
            name="repeatPassword"
            defaultValue=""
            control={control}
            render={({ field }) => (
              <ToggleValueInput
                {...field}
                errorMessage={errors.repeatPassword?.message}
                type="password"
                label={formatMessage({ id: AppMessages['profile.changePassword.confirmPassword.label'] })}
                placeholder={formatMessage({
                  id: AppMessages['profile.changePassword.confirmPassword.placeholder'],
                })}
                required
              />
            )}
          />

          <PasswordValidationInfo
            isError={isError}
            isVisible={isDirty}
            minimumPasswordLength={passwordPolicy?.minimumPasswordLength}
          />
        </Styled.Wrapper>
      </Modal>
    </>
  );
};
